import { render, staticRenderFns } from "./DownloadBackup.vue?vue&type=template&id=8110cf82&scoped=true&"
import script from "./DownloadBackup.vue?vue&type=script&lang=js&"
export * from "./DownloadBackup.vue?vue&type=script&lang=js&"
import style0 from "./DownloadBackup.vue?vue&type=style&index=0&id=8110cf82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8110cf82",
  null
  
)

export default component.exports